import React, { useState } from "react";
import MyAccountLayout from "./MyAccountLayout";
import CustomDatePicker from "../../components/CustomDatePicker";
import moment from "moment";

const BoCasinoProfitLoss = () => {
   const [filter, setFilter] = useState({
      from: moment().subtract(1, "day").format("YYYY-MM-DD HH:mm:ss"),
      to: moment().format("YYYY-MM-DD HH:mm:ss"),
    });
  return (
    <MyAccountLayout>
      <div _ngcontent-serverapp-c110 id="report" className="col-center report">
        <router-outlet _ngcontent-serverapp-c110 className="ng-star-inserted" />
        <app-parlaybethistory
          _nghost-serverapp-c123
          className="ng-star-inserted"
        >
          <div
            _ngcontent-serverapp-c123
            className="box ng-star-inserted"
            style={{
              "-webkit-align-items": "baseline",
              "-webkit-box-align": "baseline",
              "-ms-flex-align": "baseline",
              "align-items": "baseline",
            }}
          >
            <h3
              style={{
                fontSize: "24px",
                marginTop: "20px",
                marginBottom: "10px",
              }}
              _ngcontent-serverapp-c123
              className="ng-star-inserted"
            >
              BO Casino Profit & Loss
            </h3>
            {/**/}
          </div>
          {/**/}
          {/**/}
          <div _ngcontent-serverapp-c123 className="function-wrap">
            <ul _ngcontent-serverapp-c123 className="input-list">
              <div
                _ngcontent-serverapp-c123
                id="statusCondition"
                style={{ display: "none" }}
              >
                <li _ngcontent-serverapp-c123>
                  <label _ngcontent-serverapp-c123>Bet Status:</label>
                </li>
                <li _ngcontent-serverapp-c123>
                  <select
                    _ngcontent-serverapp-c123
                    name="betStatus"
                    id="betStatus"
                  />
                </li>
              </div>
              <li _ngcontent-serverapp-c123>
                <label _ngcontent-serverapp-c123>Period</label>
              </li>
           <CustomDatePicker           filter={filter}
                setFilter={setFilter}/>
            </ul>
            <ul _ngcontent-serverapp-c123 className="input-list flowroot">
              <li _ngcontent-serverapp-c123>
                <a _ngcontent-serverapp-c123 id="today" className="btn">
                  Just for today
                </a>
              </li>
              <li _ngcontent-serverapp-c123>
                <a _ngcontent-serverapp-c123 id="yesterday" className="btn">
                  From yesterday
                </a>
              </li>
              <li _ngcontent-serverapp-c123 style={{ display: "none" }}>
                <a
                  _ngcontent-serverapp-c123
                  id="last7days"
                  href="#"
                  className="btn"
                >
                  Last 7 days
                </a>
              </li>
              <li _ngcontent-serverapp-c123 style={{ display: "none" }}>
                <a
                  _ngcontent-serverapp-c123
                  id="last30days"
                  href="#"
                  className="btn"
                >
                  Last 30 days
                </a>
              </li>
              <li _ngcontent-serverapp-c123 style={{ display: "none" }}>
                <a
                  _ngcontent-serverapp-c123
                  id="last2months"
                  href="#"
                  className="btn"
                >
                  Last 2 Months
                </a>
              </li>
              <li _ngcontent-serverapp-c123 style={{ display: "none" }}>
                <a
                  _ngcontent-serverapp-c123
                  id="last3months"
                  href="#"
                  className="btn"
                >
                  Last 3 Months
                </a>
              </li>
              <li _ngcontent-serverapp-c123>
                <a _ngcontent-serverapp-c123 id="getPL" className="btn-send">
                  Get P &amp; L
                </a>
              </li>
            </ul>
          </div>
          {/**/}
          {/**/}
          <div
            _ngcontent-serverapp-c123
            id="noReportMessage"
            className="ng-star-inserted"
          >
            <p _ngcontent-serverapp-c123>
              {" "}
              Parlay History enables you to review the bets you have placed.{" "}
              <br _ngcontent-serverapp-c123 />
              Specify the time period during which your bets were placed, the
              type of markets on which the bets were placed, and the sport.{" "}
            </p>
            <p _ngcontent-serverapp-c123>
              Parlay History is available online for the past 30 days.
            </p>
            <p _ngcontent-serverapp-c123>
              User can search up to 30 days records per query only.
            </p>
          </div>
          {/**/}
          {/**/}
        </app-parlaybethistory>
        {/**/}
        {/**/}
        {/**/}
        {/**/}
      </div>
    </MyAccountLayout>
  );
};

export default BoCasinoProfitLoss;
